module.exports = __webpack_public_path__ + "img/maximize.9fc68edc.png";